import { createAsyncThunk } from "@reduxjs/toolkit";
import { CREDIT_CHECK_REASON } from "../slices/customer.slice";

export interface CreditCheckResponse {
  reason: CREDIT_CHECK_REASON;
  denied: boolean;
}

export const performCreditCheck = createAsyncThunk<CreditCheckResponse, string>(
  "customer/performCreditCheck",
  async (ssn: string) => {
    const response = await fetch(
      `${import.meta.env.VITE_LEGACY_API_URL}/checkout/creditcheck`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          personnummer: ssn,
        }),
      }
    );

    if (!response.ok) {
      throw new Error("Credit check failed");
    }

    const data = await response.json();
    const reason = data.reason as CREDIT_CHECK_REASON;

    return {
      reason,
      denied:
        reason === CREDIT_CHECK_REASON.DENIED_PREVS_CHECK ||
        reason === CREDIT_CHECK_REASON.DENIED_LOW_CREDIT,
    };
  }
);

export const subscribeToNewsletter = createAsyncThunk(
  "customer/subscribeToNewsletter",
  async ({ email, subscribe }: { email: string; subscribe: boolean }) => {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/api/mailchimp/subscribe`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, subscribe }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to handle newsletter subscription");
    }

    return response.json();
  }
);
